/**
 * Air quality sensor config - pm25, pm10, aqi, co2 for AirQualityChart
 * Reuses chartableSensorConfig, filters to air quality sensors
 */
import {
  getChartableSensors,
  CHARTABLE_SENSOR_CONFIG,
  type ChartableSensorOption,
} from './chartableSensorConfig'

export type AirQualitySensorId = 'pm25' | 'pm10' | 'aqi' | 'co2'

const AIR_QUALITY_SENSOR_IDS: AirQualitySensorId[] = ['pm25', 'pm10', 'aqi', 'co2']

/** Mock air quality sensor options when no deviceSN */
export const MOCK_AIR_QUALITY_SENSOR_OPTIONS: ChartableSensorOption[] = AIR_QUALITY_SENSOR_IDS.map(
  (id) => CHARTABLE_SENSOR_CONFIG[id]
)

/** Get air quality sensor options. When deviceSN provided, fetch and filter; otherwise use mock */
export async function getAirQualitySensors(
  deviceSN?: string | null,
  credentials?: { apiKey?: string; appId?: string }
): Promise<ChartableSensorOption[]> {
  const all = await getChartableSensors(deviceSN, credentials)
  const aqSet = new Set(AIR_QUALITY_SENSOR_IDS)
  const filtered = all.filter((s) => aqSet.has(s.id as AirQualitySensorId))
  return filtered.length > 0 ? filtered : MOCK_AIR_QUALITY_SENSOR_OPTIONS
}
